var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSaastopankki(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 206.9 206.9",
    style: {
      enableBackground: "new 0 0 206.9 206.9"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M103.3,102.3c0-7.7-2.4-14.9-6.6-20.7H82.8c6.5,4.6,10.7,12.2,10.7,20.7c0,8.6-4.3,16.2-10.8,20.8h41.2 c-6.5-4.6-10.8-12.2-10.8-20.8c0-8.5,4.2-16.1,10.7-20.7H110C105.8,87.4,103.4,94.6,103.3,102.3L103.3,102.3"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M103.3,45.3c-3.6,0-6.9,1.4-9.4,3.9c-2.5,2.5-3.9,5.9-3.9,9.5c0,3.4,0.7,5.5,1.4,7.6c0.7,2.1,1.4,3.8,2.1,5.4 c-1.6-0.7-3.3-1.4-5.4-2.1c-2.1-0.7-4.2-1.4-7.6-1.4c-3.6,0-6.9,1.4-9.4,3.9c-2.5,2.5-3.9,5.9-3.9,9.4c0,3.6,1.4,6.9,3.9,9.4 c2.5,2.5,5.9,3.9,9.4,3.9c2,0,4.1-0.4,6.1-1.5c1.3,2.8,2,5.7,2,8.8c0,1.2-0.1,2.3-0.3,3.4c-2.6,0.8-5.2,1.3-7.8,1.3 c-6.8,0-13.1-2.6-17.9-7.4c-4.8-4.8-7.4-11.1-7.4-17.9c0-13.1,10.4-24.7,23.3-24.9c0.2-12.9,11.7-23.4,24.8-23.4 c13.1,0,24.7,10.4,24.8,23.4c12.9,0.2,23.3,11.7,23.3,24.9c0,6.8-2.6,13.1-7.4,17.9c-4.8,4.8-11.1,7.4-17.9,7.4 c-2.6,0-5.2-0.4-7.8-1.3c-0.2-1.1-0.3-2.2-0.3-3.4c0-3.1,0.7-6,2-8.8c2,1.1,4.1,1.5,6.1,1.5c3.6,0,6.9-1.4,9.4-3.9 c2.5-2.5,3.9-5.9,3.9-9.4c0-3.6-1.4-6.9-3.9-9.4c-2.5-2.5-5.9-3.9-9.4-3.9c-3.4,0-5.5,0.6-7.6,1.4c-2.1,0.7-3.8,1.4-5.4,2.1 c0.7-1.6,1.4-3.3,2.1-5.4c0.7-2.1,1.4-4.2,1.4-7.6c0-3.6-1.4-6.9-3.9-9.5C110.2,46.7,106.9,45.3,103.3,45.3"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M10.8,165.6c-3.7,0-7-1.6-9.1-4.1l2.7-2.7c1.7,1.9,4.3,3,6.7,3c3.6,0,5.3-1.2,5.3-3.7c0-2-1.5-3-5.8-4.3 c-5.4-1.6-8-3-8-7.6c0-4.4,3.7-7.2,8.5-7.2c3.5,0,6.1,1.3,8.4,3.5l-2.7,2.8c-1.6-1.7-3.4-2.5-6-2.5c-3,0-4.3,1.5-4.3,3.2 c0,1.8,1.2,2.7,5.6,4c5.1,1.5,8.2,3.2,8.2,7.7C20.3,162.4,17.4,165.6,10.8,165.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M34.7,143.6c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c1.3,0,2.5,1.1,2.5,2.5 C37.2,142.4,36.1,143.6,34.7,143.6 M34.8,157c-1-0.5-2.3-0.8-4.4-0.8c-2.4,0-4,1.1-4,2.9c0,1.9,1.2,3.2,3.7,3.2 c2,0,3.8-1.2,4.7-2.5V157z M27.6,143.6c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c1.3,0,2.5,1.1,2.5,2.5 C30,142.4,28.9,143.6,27.6,143.6z M34.8,165.2v-1.9c-1.3,1.3-3.2,2.3-5.3,2.3c-3.1,0-6.7-1.8-6.7-6.5c0-4.3,3.3-6.2,7.7-6.2 c1.8,0,3.2,0.3,4.3,0.7v-1.4c0-2.1-1.3-3.3-3.6-3.3c-2,0-3.5,0.4-5,1.2l-1.5-2.9c1.8-1.1,3.9-1.7,6.6-1.7c4.3,0,7.2,2.1,7.2,6.5 v13.2H34.8z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M53.2,143.6c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c1.3,0,2.5,1.1,2.5,2.5 C55.6,142.4,54.5,143.6,53.2,143.6 M53.2,157c-1-0.5-2.3-0.8-4.4-0.8c-2.4,0-4,1.1-4,2.9c0,1.9,1.2,3.2,3.7,3.2 c2,0,3.8-1.2,4.7-2.5V157z M46,143.6c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c1.3,0,2.5,1.1,2.5,2.5 C48.5,142.4,47.3,143.6,46,143.6z M53.2,165.2v-1.9c-1.3,1.3-3.2,2.3-5.3,2.3c-3.1,0-6.7-1.8-6.7-6.5c0-4.3,3.3-6.2,7.7-6.2 c1.8,0,3.2,0.3,4.3,0.7v-1.4c0-2.1-1.3-3.3-3.6-3.3c-2,0-3.5,0.4-5,1.2l-1.5-2.9c1.8-1.1,3.9-1.7,6.6-1.7c4.3,0,7.2,2.1,7.2,6.5 v13.2H53.2z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M66.8,165.6c-2.6,0-5.4-1-7.4-2.5l1.7-2.9c1.8,1.2,3.8,1.9,5.6,1.9c2.4,0,3.5-0.8,3.5-2.1 c0-1.5-1.7-2.2-4.5-3.2c-4.1-1.6-5.6-3-5.6-6.1c0-3.4,2.7-5.2,6.6-5.2c2.4,0,4.8,0.9,6.5,2.1l-1.7,2.9c-1.6-1.1-3.2-1.7-5-1.7 c-1.8,0-2.6,0.7-2.6,1.8c0,1,0.7,1.7,3.6,2.8c4.3,1.7,6.5,2.8,6.5,6.5C74,164.2,70.6,165.6,66.8,165.6"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M86.3,164.7c-0.9,0.5-2.2,0.9-3.7,0.9c-2.7,0-4.3-1.6-4.3-5.1v-11.1h-2.7v-3.4h2.7v-5.5l3.7-2v7.5h4.8v3.4H82 v10.4c0,1.8,0.6,2.3,2,2.3c1,0,2.1-0.4,2.8-0.8L86.3,164.7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M100.5,143.7c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c1.3,0,2.5,1.1,2.5,2.5 C103,142.6,101.8,143.7,100.5,143.7 M96.9,149.1c-2.9,0-4.6,2.5-4.6,6.3c0,4.2,1.9,6.5,4.8,6.5s4.7-2.9,4.7-6.4 C101.8,151.7,99.9,149.1,96.9,149.1z M93.4,143.7c-1.4,0-2.5-1.1-2.5-2.5c0-1.4,1.1-2.5,2.5-2.5c1.3,0,2.5,1.1,2.5,2.5 C95.8,142.6,94.7,143.7,93.4,143.7z M96.9,165.6c-4.8,0-8.5-4-8.5-10c0-6.3,3.7-10,8.6-10c4.9,0,8.6,3.9,8.6,9.9 C105.6,161.9,101.9,165.6,96.9,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M116.6,149c-1.8,0-3.4,1.2-4.4,2.5v8.1c0.8,1.1,2.6,2.5,4.5,2.5c2.7,0,4.2-2.1,4.2-6.1 C120.9,151.2,119.4,149,116.6,149 M117.1,165.6c-1.9,0-3.8-1-4.8-2.2v6.9l-3.7,1.9v-26.3h3.7v1.8c1.4-1.3,3-2.2,5-2.2 c4.1,0,7.4,3,7.4,10.3C124.7,162.5,121.1,165.6,117.1,165.6z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M138.7,157c-1-0.5-2.3-0.8-4.4-0.8c-2.4,0-4,1.1-4,2.9c0,1.9,1.2,3.2,3.7,3.2c2,0,3.8-1.2,4.7-2.5V157  M138.7,165.2v-1.9c-1.3,1.3-3.2,2.3-5.3,2.3c-3.1,0-6.7-1.8-6.7-6.5c0-4.3,3.3-6.2,7.7-6.2c1.8,0,3.2,0.3,4.3,0.7v-1.4 c0-2.1-1.3-3.3-3.6-3.3c-2,0-3.5,0.4-5,1.2l-1.5-2.9c1.8-1.1,3.9-1.7,6.6-1.7c4.3,0,7.2,2.1,7.2,6.5v13.2H138.7z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M157.8,165.2v-10.9c0-3.9-1.5-5.3-4-5.3c-2.5,0-4,1.8-4,4.9v11.3h-3.8v-19.3h3.8v1.8c1-1.4,2.9-2.2,4.8-2.2 c4.5,0,6.9,2.9,6.9,8.6v11H157.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M176.2,165.2l-4.3-9.6l-2.9,3.9v5.7h-3.8v-24.7l3.8-2v12.1c0,1.2,0,3.2,0,4.1c0.5-0.8,1.5-2.2,2.1-3.2l4-5.6 h4.3l-4.9,6.5l5.8,12.8H176.2"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M193.8,165.2l-4.3-9.6l-2.9,3.9v5.7h-3.8v-24.7l3.8-2v12.1c0,1.2,0,3.2,0,4.1c0.5-0.8,1.5-2.2,2.1-3.2l4-5.6 h4.3l-4.9,6.5l5.8,12.8H193.8"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      fill: "#00B5D0"
    },
    d: "M204.4,165.2h-3.8v-19.3h3.8V165.2z M202.6,143.5c-1.4,0-2.5-1.1-2.5-2.4c0-1.4,1.1-2.5,2.5-2.5 c1.3,0,2.4,1.1,2.4,2.5C205,142.4,203.9,143.5,202.6,143.5z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaastopankki);
export default __webpack_public_path__ + "static/media/saastopankki.eeb967f2d7e1270594f4d62cc7a6ad1a.svg";
export { ForwardRef as ReactComponent };